import { AuthorCard } from '../interfaces/author-card.interface';

export const plananualchileb: AuthorCard[] = [
  {
    name: 'Los Robots',
    id: 34628,
    owner: {
      id: 36212,
      email: 'contacto@simarobot.com',
      name: 'Plan Anual de Chile',
      organizations: [{ name: 'Plan Anual de Chile' }],
    },
    biography:
      'Actividades lúdicas, que favorecen el desarrollo del lenguaje y comunicación en niños y niñas de primero básico',
    lock: true,
    level: 'pb',
    urlteacher: 'https://app.box.com/s/b4qj4aafy411qo3wkd5aappzzy0bca7c',
    //urlpartent: 'https://app.box.com/s/wf4vdhzavwtrewbw8z4z4e6xpt948rjq',
    typeact: "unique",
    month:"69905"
  },
  {
    name: 'Los Robots',
    id: 34629,
    owner: {
      id: 36212,
      email: 'contacto@simarobot.com',
      name: 'Plan Anual de Chile',
      organizations: [{ name: 'Plan Anual de Chile' }],
    },
    biography:
      'Actividades lúdicas, que favorecen el desarrollo del lenguaje y comunicación en niños y niñas de primero básico',
    lock: true,
    level: 'pb',
    urlteacher: 'https://app.box.com/s/b4qj4aafy411qo3wkd5aappzzy0bca7c',
    //urlpartent: 'https://app.box.com/s/wf4vdhzavwtrewbw8z4z4e6xpt948rjq',
    typeact: "unique",
    month:"69905"
  },
  {
    name: 'El Verano',
    id: 18301,
    owner: {
      id: 36212,
      email: 'contacto@simarobot.com',
      name: 'Plan Anual de Chile',
      organizations: [{ name: 'Plan Anual de Chile' }],
    },
    biography:
      'English activities designed as short learning capsules for 7th, 8th and 9th grades',
    lock: false,
    level: 'pb',
    urlteacher: 'https://app.box.com/s/knj3u008ehqvyd3redo84qv1dcl1zk45',
    //urlpartent: 'https://app.box.com/s/dj3ety6vvj07n38rsv8bdcyetvs37xh8',
    typeact: "unique",
    month:"69905"
  },
  {
    name: 'Hagamos un Experimento',
    id: 21068,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'contacto@simarobot.com',
      name: 'Plan Anual de Chile',
      organizations: [{ name: 'Plan Anual de Chile' }],
    },
    typeact: "unique",
    month:"69906",
    urlteacher:'https://app.box.com/s/73f5p4opc6qpvgfpr4f39vlybk9wr9k2',
    //urlpartent:"https://app.box.com/s/ha5wa2er1hpf99lt864v06eo8zx1ke8j"
  },
  {
    name: 'Día de la Actividad Física',
    id: 33703,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"69906",
    urlteacher:'https://app.box.com/s/uuu3dssn5dhogjc2df441si4muu7pstt',
    //urlpartent:"https://app.box.com/s/64wcokb440kl97vypjc9ip4pvnlvsskc"
   },
  {
    name: 'Día de la Tierra',
    id: 21064,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact:"unique",
    month:"69906",
    urlteacher:'https://app.box.com/s/cnjixl8kscs09jgw58l50yec9s5zqkc3',
    //urlpartent:"https://app.box.com/s/of173kfpcilg03gqynet53cjj0wwba52"  
  },
  {
    name: 'Día del Libro',
    id: 21063,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact:"unique",
    month:"69906",
    urlteacher:'https://app.box.com/s/8e9iap3nu57ptbz5xlkggnryiru75j8v',
    //urlpartent:"https://app.box.com/s/xlwafaf6vy4yoz6edsjwsb324i8fgr6v" 
  },
  {
    name: 'Día de los mamíferos marinos',
    id: 34694,
    biography:
      'Actividades lúdicas, que favorecen el desarrollo del lenguaje y comunicación en niños y niñas de primero básico',
    lock: true,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"69938",
    urlteacher:'https://app.box.com/s/aos27z9eeovfu4gsm64c5xf5md6qa8dz',
    //urlpartent:"https://app.box.com/s/a7d4ssuiifnnxow3srhqaw0kcgwq06yf"  
  },
  {
    name: 'Día del y la estudiante',
    id: 34693,
    biography:
      'English activities designed as short learning capsules for 7th, 8th and 9th grades',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"69938",
    urlteacher:'https://app.box.com/s/cnglvrg15j8htdbuf0540rplh7l3036n',
    //urlpartent:"https://app.box.com/s/1zm27euf48nlh0ud8k8y1xaypmk1843a"  
  },
  {
    name: 'Vida de las plantas',
    id: 34692,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"69938",
    urlteacher:'https://app.box.com/s/klanxuwd2qc2y5ckuzu4up5h0fd8osx4',
    //urlpartent:"https://app.box.com/s/pzpei2y8qlauptcjci100mgdd3yjy2f5" 
  },
  {
    name: 'El otoño',
    id: 33900,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"69938",
    urlteacher:'https://app.box.com/s/htr5db6al5y6j4n8ematprxgcbi32sh1',
    //urlpartent:"https://app.box.com/s/6tff96fkz3lwaj1sa25feritvgwkao39"  
  },
  {
    name: 'Somos artistas',
    id: 34695,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"69938",
    urlteacher:'https://app.box.com/s/2v81bdwjo9twmw9ywevgskrsletuarhu',
    //urlpartent:"https://app.box.com/s/0grg06uisq2wxnjiyhqlpcmtdhr70vdl" 
  },
  {
    name: 'Nuestros mares y océanos',
    id: 34759,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"69939",
    urlteacher:'https://app.box.com/s/hypvmph8en2mqrm9mkw7t6gnbtvgs1m7',
    //urlpartent:"https://app.box.com/s/slhtte68a6wezl4u43rlfrju4sqjfe71"  
  },
  {
    name: 'Las profesiones',
    id: 18325,
    biography:
      'Actividades lúdicas, que favorecen el desarrollo del lenguaje y comunicación en niños y niñas de primero básico',
    lock: true,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"69939",
    urlteacher:'https://app.box.com/s/qsu2ebmv0r1l6ata1j0kkxzaof092utb',
    //urlpartent:"https://app.box.com/s/wiib01jtapr2xhc7zo6lhq641yepv4oe" 
  },
  {
    name: 'Un ambiente saludable',
    id: 18327,
    biography:
      'English activities designed as short learning capsules for 7th, 8th and 9th grades',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"69939",
    urlteacher:'https://app.box.com/s/dbzcrtw7gqw4nv0untiqzmyjmsc9ds4v',
    //urlpartent:"https://app.box.com/s/ir6n7ytqpn96ql0igh8kw88f6pbr7bwx" 
  },
  {
    name: 'Día de la bandera nacional',
    id: 34725,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"369941",
    urlteacher:'https://app.box.com/s/x7he65867b7ssma3tbdz0mo9c7ugnw1q',
    //urlpartent:"https://app.box.com/s/hiu3azm5o3nhytcq2q8kkk4y5w3ypqkp" 
  },
  {
    name: 'El invierno',
    id: 18332,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"69941",
    urlteacher:'https://app.box.com/s/q8sc6xkf3r8uku9j5tqy1dc8tmsokikq',
    //urlpartent:"https://app.box.com/s/zd4fl01aq1y1uqjqwe2pyt71zhpglgeg" 
  },
  {
    name: 'Juegos y danzas chilenas',
    id: 18358,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70039",
    urlteacher:'https://app.box.com/s/1yq06d9czmfjsluzcyhr64c5lyvh787a',
    //urlpartent:"https://app.box.com/s/m395ljr9onb3b36ztcwgtekjw8gik0d4" 
  },
  {
    name: 'Nuestra cultura popular',
    id: 34760,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70039",
    urlteacher:'https://app.box.com/s/ztyswr1v9o96pq3abr4tigdweapsfb9j',
    //urlpartent:"https://app.box.com/s/69rhgsr05fkd310awqfwwlil24frmm3u" 
  },
  {
    name: 'Día del Folklore',
    id: 34761,
    biography:
      'Actividades lúdicas, que favorecen el desarrollo del lenguaje y comunicación en niños y niñas de primero básico',
    lock: true,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70039",
    urlteacher:'https://app.box.com/s/zhjh9419zsyr226i5za4oa80hdvo1glg',
    //urlpartent:"https://app.box.com/s/nki83x4pzstr0kdyf4sda4rbxjfcig9o"
  },
  {
    name: 'Fiestas patrias chilenas',
    id: 18362,
    biography:
      'English activities designed as short learning capsules for 7th, 8th and 9th grades',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70040",
    urlteacher:'https://app.box.com/s/qcanfyyyus8l4zdrffi8dfs4f04ib6s1',
    //urlpartent:"https://app.box.com/s/hk4n8z80wn4fmicrflmr1agnqj2khyqy" 
  },
  {
    name: 'Grandes mujeres chilenas',
    id: 18363,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70040",
    urlteacher:'https://app.box.com/s/8yolbveu78a6eluxfhdnn7npzz5tcjdr',
    //urlpartent:"https://app.box.com/s/eikndh5dnhab1w6bfhq1l9crtpm2v4eh" 
  },
  {
    name: 'Conozcamos la cueca y el hueso',
    id: 34762,
    biography: '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70040",
    urlteacher:'https://app.box.com/s/y762zglynrtog849587kkz9iuzkphmac',
    //urlpartent:"https://app.box.com/s/3q103u6nlgpez5g4ma2mhqpke5k1tzas" 
  },
  {
    name: 'Mi móvil dieciochero',
    id: 18365,
    biography: '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36714",
    urlteacher:'https://app.box.com/s/45yjjkhryt55yx4sq6fio6f2smmrpis7',
    //urlpartent:"https://app.box.com/s/hw4sg0wo1lrhgvhttqvs8e8rjzvnw3xd" 
  },
  {
    name: 'Día del patrullero escolar',
    id: 34792,
    biography: '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70041",
    urlteacher:'https://app.box.com/s/cdno5rdjjacpbipjinjubo8vznlto8ft',
    //urlpartent:"https://app.box.com/s/4c10nyhif5h3m1qc4tkgg6b9qm7iib69" 
  },
  {
    name: 'Día del Encuentro de dos mundos',
    id: 34660,
    biography:
      'Actividades lúdicas, que favorecen el desarrollo del lenguaje y comunicación en niños y niñas de primero básico',
    lock: true,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70041",
    urlteacher:'https://app.box.com/s/6zy15ucg4muj7d5gisfhgqlbkhs7aqkf',
    //urlpartent:"https://app.box.com/s/eeono8ty1mzlpxf294zew3k4drbx92y6" 
  },
  {
    name: '¿Qué es la interculturalidad?',
    id: 34791,
    biography:
      'English activities designed as short learning capsules for 7th, 8th and 9th grades',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70041",
    urlteacher:'https://app.box.com/s/6hm1vhdp56n3uv4l9va3fo0z84q97iyk',
    //urlpartent:"https://app.box.com/s/0bysiek2aj0t3a774x0igcfpz1plrf78" 
  },
  {
    name: 'Mi querido profesor',
    id: 34793,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70041",
    urlteacher:'https://app.box.com/s/p83cnl70pilchz83x0cuc21ipp1fl4vm',
    //urlpartent:"https://app.box.com/s/o2e252nby8n02bs3i7zk9qt5vmceq1b5"
  },
  {
    name: 'La Primavera',
    id: 33835,
    biography: '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70041",
    urlteacher:'https://app.box.com/s/p83cnl70pilchz83x0cuc21ipp1fl4vm',
    //urlpartent:"https://app.box.com/s/id6799vzquzfx5wcmd1okj24hkmgcvem" 
  },
  {
    name: 'Educación para todos',
    id: 18396,
    biography: '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70103",
    urlteacher:'https://app.box.com/s/otj6adzjq4bo9k0wln8lhrlmav7xlaa8',
    //urlpartent:"https://app.box.com/s/906buzoc57as5wh80qcpwy3wwts4nyog" 
  },
  {
    name: 'Entre rimas',
    id: 34795,
    biography: '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70103",
    urlteacher:'https://app.box.com/s/uatd2w637o96vpd4r74s1ijxrpxkbg6n',
    //urlpartent:"https://app.box.com/s/p1z1g1fiqb0tyc6mbd9i7c8kanlq0u45"  
  },
  {
    name: 'Somos únicos',
    id: 34796,
    biography:
      'Actividades lúdicas, que favorecen el desarrollo del lenguaje y comunicación en niños y niñas de primero básico',
    lock: true,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70104",
    urlteacher:'https://app.box.com/s/rzbic5lhclxailh9n0mmxadsrmg2eyvt',
    //urlpartent:"https://app.box.com/s/irwpt79pfj06h04yhs1b9ay6ztpyvr79" 
  },
  {
    name: 'Melodías navideñas',
    id: 18428,
    biography:
      'English activities designed as short learning capsules for 7th, 8th and 9th grades',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70104",
    urlteacher:'https://app.box.com/s/4chx3nn1hiqrmo9zkpmok4s2vykd23k8',
    //urlpartent:"https://app.box.com/s/lbs6o09u1uzimhbdntznuo0xh5l8f5os"  
  },
  {
    name: 'Feliz Navidad',
    id: 18427,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"70104",
    urlteacher:'https://app.box.com/s/ayylh2zmlnfsc9k572m6spvbwpu7vxh7',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Día Internacional de la Mujer',
    id: 71556,
    biography:
      '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Marzo",
    urlteacher:'',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Día contra el ciber-acoso',
    id: 71557,
    biography:
      '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Marzo",
    urlteacher:'',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Los Derechos de los Niños',
    id: 71559,
    biography:
      '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Abril",
    urlteacher:'https://app.box.com/s/q8tcylgo46oxmmyzam9p98n8tyjswvn0',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Día Nacional de las Ciencias',
    id: 70109,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Abril",
    urlteacher:'https://app.box.com/s/8b5stro8o1q6fcl6q1xl7jungtk58uce',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Día del Estudiante',
    id: 70137,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Mayo",
    urlteacher:'https://app.box.com/s/nw9nc68cp8g3oank63hdufw1pmo464js',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Día de la Bandera',
    id: 70139,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Julio",
    urlteacher:'https://app.box.com/s/bh37m57mkbaxibjhybooyn55cwizd5s8',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Día del Folklore',
    id: 70142,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Agosto",
    urlteacher:'https://app.box.com/s/845e2k06f2a3blrnxq34rnkozyyx6ua3',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Día de la música',
    id: 70143,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Octubre",
    urlteacher:'https://app.box.com/s/xoum477gd9j6o8nov4wg0sv448qwz1up',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: '¡Día del técnico en educación parvularia!',
    id: 70145,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Octubre",
    urlteacher:'https://app.box.com/s/yg6np6gqzqf37n77drpyk49tx43o3il8',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Encuentro de Dos Mundos',
    id: 70147,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Octubre",
    urlteacher:'https://app.box.com/s/vxdsce65ebb8m5dedpi4orvcm94q4wsr',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Día del Profesor',
    id: 70149,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Octubre",
    urlteacher:'https://app.box.com/s/zqcescvf9x57nb3v1u493rn3pt80etco',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  }
];